<template>
  <div class="progress">
    <el-progress :stroke-width="38" :percentage="_percentage" stroke-linecap="butt" color="#ff9300" :show-text="false" />
    <div class="progress-text" :class="{'t-w': step > parseInt(this.total / 1.75)}">答题进度{{ _percentage }}%</div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      stepGroup_5: [1, 2, 3, 4, 5],
      progressGroup_5: [20, 40, 60, 80, 100],
      stepGroup_6: [1, 2, 3, 4, 5, 6],
      progressGroup_6: [10, 20, 40, 60, 80, 100],
      stepGroup_7: [1, 2, 3, 4, 5, 6, 7],
      progressGroup_7: [5, 10, 20, 40, 60, 80, 100],
    }
  },
  computed: {
    _percentage() {
      return this[`progressGroup_${this.total}`][this[`stepGroup_${this.total}`].findIndex(item => item === this.step)];
    }
  },
}
</script>

<style lang="scss" scoped>
.progress {
  border: 2px solid #197aff;
  padding: 2px;
  border-radius: 8px;
  margin-bottom: 64px;
  position: relative;

  &-text {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: .7s;
  }
}

::v-deep {
  .el-progress-bar__outer {
    background-color: inherit !important;
    border-radius: 8px !important;

    .el-progress-bar__inner {
      border-radius: 8px !important;
    }
  }
}
</style>